module.exports = __webpack_public_path__ + "static/img/Voncken-Samuel.3f5e58e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/Voncken-Samuel.jpg
// module id = z5Ar
// module chunks = 1